import colors from 'styles/variables/colors.module.scss';
import { Color } from 'types/colors';

/**
 * Возвращает цвет из scss-переменных
 */
export const getColor = (color: Color): string => colors[color];
